$(document).ready(function () {
    $('.menu-sidebar.menu > li').click(function (e) {
        if (isMobile() && !$(e.target).is('a')) {
            e.preventDefault();
            e.stopPropagation();
            $(e.target).css('max-height', 'unset');

            if(!$(e.target).hasClass('active')) {
                $(e.target).find('ul').first().slideUp();
            } else {
                $(e.target).find('ul').first().slideDown();
            }
        }
    });

    $('.menu-sidebar.menu > li ul li').click(function (e) {
        if (isMobile() && !$(e.target).is('a')) {
            var $this = $(this);
            e.preventDefault();
            e.stopPropagation();

            $this.toggleClass('active');
            $this.find('ul.sub-menu').first().slideToggle();

            $this.siblings().find('ul.sub-menu').slideUp(400);
            $this.siblings().removeClass('active');

            // var scroll_top = $this.offset().top - $('.mobile_cat > ul').offset().top + $('.mobile_cat > ul').scrollTop();
            // $('.mobile_cat > ul').animate({scrollTop: scroll_top }, 'slow');
        }
    });
});
